import { Trip } from "@/fetch/gworld";
import create from "zustand";
import { persist } from "zustand/middleware";

type AcademyBannerState = {
  showAcademyBanner: boolean | null | undefined;
  setShowAcademyBanner: (current: boolean | null | undefined) => void;
};

const useAcademyBannerStore = create(
  persist<AcademyBannerState>(
    (set) => ({
      showAcademyBanner: true,
      setShowAcademyBanner: (showAcademyBanner) => set({ showAcademyBanner }),
    }),
    {
      name: "show-academy-banner",
    }
  )
);

const useAcademyBannerState = () => {
  const { showAcademyBanner, setShowAcademyBanner } = useAcademyBannerStore();

  return { showAcademyBanner, setShowAcademyBanner };
};

export default useAcademyBannerState;
